// src/services/auditLogger.js

const AUDIT_API_URL = process.env.REACT_APP_AUDIT_API_URL;

/**
 * Base method to dispatch telemetry events to the PHP backend.
 */
export async function sendAuditEvent({
  eventType,
  action = 'EXECUTE',
  status = 'SUCCESS',
  targetEntity = null,
  targetId = null,
  requestData = null,
  oldValues = null,
  newValues = null,
  metadata = {},
  userId = null,
  userRole = null
}) {
  const payload = {
    eventType,
    action: action.toUpperCase(),
    status: status.toUpperCase(),
    targetEntity,
    targetId: targetId ? String(targetId) : null,
    requestData,
    oldValues,
    newValues,
    metadata: {
      url: window.location.href,
      pathname: window.location.pathname,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      referrer: document.referrer || null,
      ...metadata
    },
    userId,
    userRole,
    userAgent: navigator.userAgent
  };

  try {
    await fetch(AUDIT_API_URL + '/audit/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
      keepalive: true // Retains HTTP request context across route/page unload
    });
  } catch (error) {
    console.error('Audit telemetry failed:', error);
  }
}